import React from 'react';
import { styled } from '@mui/material/styles';
import { AppBar, Toolbar, Link, Box, Typography, Button } from '@mui/material';
import { useCommonTranslation } from '../../hooks/useCommonTranslation';
import AboutDialog from './AboutDialog';

const PREFIX = 'HomeFooterBar';

const classes = {
  appbar: `${PREFIX}-appbar`,
  toolbar: `${PREFIX}-toolbar`,
  logo: `${PREFIX}-logo`,
  link: `${PREFIX}-link`,
};

const StyledAppBar = styled(AppBar)(({ theme }) => ({
  [`&.${classes.appbar}`]: {
    color: '#fff',
    bottom: 0,
    top: 'auto',
    backgroundColor: '#011012',
    height: '10%',
    paddingBottom: '5%',
  },

  [`& .${classes.toolbar}`]: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '1%',
    marginBottom: 30,
  },

  [`& .${classes.logo}`]: {
    width: '10%',
    resizeMode: 'contain',
  },

  [`& .${classes.link}`]: {
    marginLeft: 48,
  },
}));

export default function HomeFooterBar() {
  const t = useCommonTranslation();
  const { __environment__ } = window as any;

  const [version, setVersion] = React.useState<string>();
  const [aboutBoxOpen, setAboutBoxOpen] = React.useState(false);
  const [showApiVersionContent, setApiVersionContent] = React.useState(false);

  React.useEffect(() => {
    const fullVersion = __environment__.REACT_APP_VERSION.split('.');
    setVersion(`${fullVersion[0]}.${fullVersion[1]}`);
  }, []);

  const setFullVersion = () => {
    setVersion(__environment__.REACT_APP_VERSION);
  };

  const toggleAboutBox = () => {
    setAboutBoxOpen(!aboutBoxOpen);
  };

  return (
    <StyledAppBar position="relative" className={classes.appbar}>
      <Toolbar variant="dense" className={classes.toolbar}>
        <img src="/logo2.png" alt="logo" className={classes.logo} />
        <Typography onDoubleClick={setFullVersion}>
          {t('footer.version')} {version}
        </Typography>
        <Box>
          {t('footer.questions')}&nbsp;
          <Link
            href="https://americanlogistics.com/privacy/"
            color="inherit"
            className={classes.link}
            underline="hover"
            target="_blank">
            {t('footer.privacyTerms')}
          </Link>
          <Link
            href="#"
            color="inherit"
            className={classes.link}
            underline="hover"
            onClick={toggleAboutBox}>
            {t('footer.about')}
          </Link>
        </Box>
      </Toolbar>
      {aboutBoxOpen && (
        <AboutDialog open={aboutBoxOpen} onClose={toggleAboutBox} />
      )}
    </StyledAppBar>
  );
}
